import { ResourcefulReducer } from '../../util';
import MessageModel from '../models/message_model';
import ACTIONS from '../actions';

const MessageReducer = new ResourcefulReducer('messages', MessageModel, {
  actionTypes: [ACTIONS.LIST_MESSAGES.success, ACTIONS.FETCH_MESSAGE.success, ACTIONS.CREATE_MESSAGE_success, ACTIONS.UPDATE_MESSAGE_success],
});

export default MessageReducer;
